import { render, staticRenderFns } from "./ImpotOrder.vue?vue&type=template&id=22677d71&"
import script from "./ImpotOrder.vue?vue&type=script&lang=js&"
export * from "./ImpotOrder.vue?vue&type=script&lang=js&"
import style0 from "./ImpotOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports